module.exports = __webpack_public_path__ + "files/810db3d26ec8a56bfd7a1435acacd9b1.png";